import Extend from 'flarum/common/extenders';
import commonExtend from '../common/extend';
import ForumsPage from './components/ForumsPage';
import DonatePage from './components/DonatePage';
export default [...commonExtend, new Extend.Routes().add('nh.forums', '/forums', ForumsPage).add('nh.donate', '/donate', DonatePage)];